// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3cd_i","requiredAsterisk":"Info_requiredAsterisk__16Caa"};